import { render, staticRenderFns } from "./TeaserWidget.vue?vue&type=template&id=18161d5a&scoped=true&"
import script from "./TeaserWidget.vue?vue&type=script&lang=ts&"
export * from "./TeaserWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TeaserWidget.vue?vue&type=style&index=0&id=18161d5a&prod&lang=scss&"
import style1 from "./TeaserWidget.vue?vue&type=style&index=1&id=18161d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18161d5a",
  null
  
)

export default component.exports